import React from 'react';
import { Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { Bar } from "react-chartjs-2";
import { diagramColors } from './colors';

const options = {
    maintainAspectRatio: false,
    legend: {
        display: false,
    },
    tooltips: {
        backgroundColor: "#f5f5f5",
        titleFontColor: "#333",
        bodyFontColor: "#666",
        bodySpacing: 4,
        xPadding: 12,
        mode: "nearest",
        intersect: 0,
        position: "nearest",
    },
    responsive: true,
    scales: {
        yAxes: {
            gridLines: {
                drawBorder: false,
                color: "rgba(225,78,202,0.1)",
                zeroLineColor: "transparent",
            },
            ticks: {
                suggestedMin: 60,
                suggestedMax: 120,
                padding: 20,
                fontColor: "#9e9e9e",
            },
        },
        xAxes: {
            gridLines: {
                drawBorder: false,
                color: "rgba(225,78,202,0.1)",
                zeroLineColor: "transparent",
            },
            ticks: {
                padding: 20,
                fontColor: "#9e9e9e",
            },
        },
    },
};

const BarChart = ({title, legend, icon, total, input, colorScheme}) => {
    const { t } = useTranslation();
    if(!input)return null
    const values = Object.values(input)
    const labels = Object.keys(input).map(label => t(`reports.kpis.${label}`));

    const data = (canvas) => {
        const ctx = canvas.getContext("2d");
        const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
        gradientStroke.addColorStop(1, diagramColors[colorScheme].gradient[0]);
        gradientStroke.addColorStop(0.4, diagramColors[colorScheme].gradient[1]);
        gradientStroke.addColorStop(0, diagramColors[colorScheme].gradient[2]); 
            
        return {
          labels: labels,
          datasets: [
            {
              label: legend,
              fill: true,
              backgroundColor: gradientStroke,
              hoverBackgroundColor: gradientStroke,
              borderColor: diagramColors[colorScheme].border,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: values,
            },
          ],
        };
      }

    return (
        <Card className="card-chart">
            <CardHeader>
                <h5 className="card-category" style={{cursor:"default"}}>{title}</h5>
                <CardTitle tag="h3" style={{cursor:"default"}}>
                    <i className={`tim-icons ${icon} text-primary`} />
                    {" "}
                    {total}
                </CardTitle>
            </CardHeader>
            <CardBody>
                <div className="chart-area">
                    <Bar data={data} options={options}/>
                </div>
            </CardBody>
        </Card>
    );
};

export default BarChart;